import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import UserModal from '../../common/UserModal'

import * as Functions from '../../../helpers/Functions'
import * as Strings from './strings'
import * as configActions from '../../actions/Config'
import * as usersActions from '../../actions/Users'

class NewUserModal extends Component {
  state = {
    emailInput: '',
    passwordInput: '',
    errorEmail: '',
    errorPassword: '',
    errorMessage: '',
    admin: false
  }

  componentWillReceiveProps(nextProps) {
    const { users } = this.props

    if (
      !nextProps.users.isCreating &&
      nextProps.users.errorCreating === null &&
      users.isCreating
    ) {
      this.resetFields()
      this.props.hideNewUserModal()
      this.props.showSnackbar(Strings.default.USER_CREATED)
    } else if (
      !nextProps.users.isCreating &&
      nextProps.users.errorCreating !== null &&
      users.isCreating
    ) {
      if (nextProps.users.errorCreating === 409) {
        this.setState({ errorEmail: Strings.default.EMAIL_IN_USE })
      } else {
        this.setState({ errorMessage: Strings.default.INTERNAL_ERROR })
      }
    }
  }

  resetFields() {
    this.setState({
      emailInput: '',
      passwordInput: '',
      errorEmail: '',
      errorPassword: '',
      errorMessage: '',
      admin: false
    })
  }

  createUser() {
    const { data, user, users } = this.props
    const { emailInput, passwordInput } = this.state

    this.setState({ errorMessage: '' })

    if (emailInput === '' || !Functions.isValidEmail(emailInput)) {
      if (emailInput === '') {
        this.setState({ errorEmail: Strings.default.MANDATORY_FIELD })
      } else {
        this.setState({ errorEmail: Strings.default.NOT_VALID_EMAIL })
      }
    }

    if (passwordInput === '') {
      this.setState({ errorPassword: Strings.default.MANDATORY_FIELD })
    }

    if (
      emailInput !== '' &&
      passwordInput !== '' &&
      Functions.isValidEmail(emailInput)
    ) {
      const postData = {
        email: this.state.emailInput,
        password: this.state.passwordInput,
        admin: this.state.admin
      }

      this.props.tryCreateUser(
        user.token,
        data.community.id,
        users.apartmentId,
        postData
      )
    }
  }

  render() {
    const { config, users } = this.props
    const {
      emailInput,
      passwordInput,
      admin,
      errorEmail,
      errorPassword,
      errorMessage
    } = this.state

    return (
      <UserModal
        show={config.newUserModal.show}
        hide={() => {
          this.resetFields()
          this.props.hideNewUserModal()
        }}
        emailInput={emailInput}
        onChangeEmailInput={text =>
          this.setState({ emailInput: text, errorEmail: '', errorMessage: '' })
        }
        errorEmail={errorEmail}
        passwordInput={passwordInput}
        onChangePasswordInput={text =>
          this.setState({
            passwordInput: text,
            errorPassword: '',
            errorMessage: ''
          })
        }
        errorPassword={errorPassword}
        isAdmin={admin}
        onChangeIsAdmin={checked =>
          this.setState({ admin: checked, errorMessage: '' })
        }
        header={Strings.default.NEW_USER}
        information={Strings.default.NEW_USER_INFORMATION}
        onDone={() => this.createUser()}
        withPassword
        loading={users.isCreating}
        errorMessage={errorMessage}
      />
    )
  }
}

function mapStateToProps({ config, data, user, users }) {
  return { config, data, user, users }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...configActions, ...usersActions }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(NewUserModal)



// WEBPACK FOOTER //
// ./src/components/containers/NewUserModal/index.js